import { Injectable } from '@angular/core';  
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
  
@Injectable() export class ConfirmDialogService {  
    private subject = new Subject<any>();  
  
    showConfirm(message: string, yesFn: () => void, noFn: () => void, link?: { text: string, url: string, textBefore?: string, textAfter?: string }): any {
        this.setConfirmation(message, 'confirm', yesFn, noFn, link);
    }
    showAlert(message: string, yesFn: () => void, noFn: () => void): any {
        this.setConfirmation(message, 'alert', yesFn, noFn);
    }

    private setConfirmation(message: string, type: string, yesFn: () => void, noFn: () => void, link?: { text: string, url: string, textBefore?: string, textAfter?: string }): any {
        const that = this;
        this.subject.next({
            type: type,
            text: message,
            link: link,
            yesFn() {
                that.subject.next(); // This will close the modal
                yesFn();
            },
            noFn() {
                that.subject.next();
                noFn();
            }
        });

    }  
  
    getMessage(): Observable<any> {  
        return this.subject.asObservable();  
    }  
}  


// WEBPACK FOOTER //
// ./src/app/core/components/confirm-dialog/confirm-dialog.service.ts